import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { observer } from 'mobx-react';

import { IRewardOffersPageData } from '../../../domain/pages/IRewardOffersPageData';
import { PassengersPageId } from '../../../../app/pages/domain/constants/PageId';
import { useUrlForPageId } from '../../../../app/pages/ui/utils/useUrlForPageId';
import { useAuthStore } from '../../../../auth/shared/store/useAuthStore';
import {
	getOverlapWithHeaderStyles,
	PageHeader,
	StyledHeader,
} from '../../../../shared/components';
import { PageLayout } from '../../../../shared/layout/page/PageLayout';
import { useLoyaltyAccountStore } from '../../../domain/stores/useLoyaltyAccountStore';
import { CurrentTierPoints } from '../../current-tier-points/CurrentTierPoints';
import { RewardOffers } from './RewardOffers';
import { Sections } from '../../../../content-sections/ui';
import { PageMetaData } from '../../../../shared/layout/page/PageMetaData';
import { useRedirectIfNotAuthenticated } from '../../../../auth/shared/store/useRedirectIfNotAuthenticated';
import { trackScreen } from '../../../../shared/analytics/event/trackScreen';
import { ScreenNames } from '../../../../shared/analytics/user/constants';

interface IRewardOffersPageProps extends IRewardOffersPageData {}

export const RewardOffersPage = observer(({ page }: IRewardOffersPageProps) => {
	const { isAuthenticated } = useAuthStore();
	const loyaltyDetailsStore = useLoyaltyAccountStore();

	const redirectUrl = useUrlForPageId(PassengersPageId.Home);
	useRedirectIfNotAuthenticated(redirectUrl);

	useEffect(() => {
		trackScreen({ screenName: ScreenNames.RewardOffers });
	}, []);

	if (!isAuthenticated) {
		// We need to return metadata here, otherwise no <title> is rendered server-side, causing accessibility checks to fail.
		return <PageMetaData page={page} />;
	}

	return (
		<PageLayout page={page} overlapContentWithHeader>
			<PageHeader page={page} parentTitle="" />
			<StyledContentWrap backgroundTheme="purple-blue">
				<CurrentTierPoints store={loyaltyDetailsStore} />
				<RewardOffers showNoRewardsAvailableContainer />
				{page.fields.sections && <Sections sections={page.fields.sections} />}
			</StyledContentWrap>
		</PageLayout>
	);
});

const StyledContentWrap = styled.div`
	${StyledHeader} + style + &,
  	${StyledHeader} + & {
		${getOverlapWithHeaderStyles}
	}
`;
